/**
 * Mixin for most input field components.
 */
import { Component, Prop, Vue } from 'vue-property-decorator'
import { InputField } from '@/components/ui/DynamicTechTaskCard/types'


@Component
export default class InputFieldMixin<O> extends Vue {
    @Prop({ required: true }) inputField!: InputField
    @Prop({ required: true }) disabled!: boolean
    @Prop({ required: true }) loading!: boolean

    get inputData(): { [key: string]: unknown } {
        return this.$store.state.techTask.inputData
    }

    get taskName(): string {
        return this.$store.state.techTask.taskName
    }

    get inputOptions(): O {
        return this.inputField.inputOptions as unknown as O
    }
}
